/**
 *
 */

import React from "react";

function RightArrow(props: any) {
  return <span {...props}>→</span>;
}

export default RightArrow;
